import type {Env} from '@hconnect/common/hproduce'
import {settings} from '@hconnect/common/hproduce/config/settings'

export const getKilnSetupRedirectUrl = (
  plantId: string,
  nodeUpmId: string,
  settingsTab: 'layout' | 'heatZones' | 'drillingZones' | 'general'
) => {
  const settingsBaseUrl = settings.url[process.env.REACT_APP_STAGE as Env].replace(
    '{plantId}',
    plantId
  )
  const settingsPlantSetupUrl = `plantSetup/${nodeUpmId}/${settingsTab}`
  return `${settingsBaseUrl}/${settingsPlantSetupUrl}`
}
